/**
 * Files above this size use the TUS resumable protocol (chunked, resumes after
 * a network hiccup) via the shared `uploadFileWithProgress`; smaller files keep
 * the direct `supabase.storage.upload` path. Production IFCs reach 1 GB+, so
 * resumability matters for real BIM uploads (WHA-3535).
 *
 * The actual size ceiling is enforced by `UploadQueueStore.MAX_FILE_SIZE`, not
 * here — keep gating logic there.
 */
export const RESUMABLE_THRESHOLD_BYTES = 50 * 1024 * 1024;
